export default {"src":"/_next/static/media/arrow-down.ac91f248.svg","height":12,"width":12};